<template>
  <b-row>
    <b-col cols="12">
      <newness-table />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import NewnessTable from './NewnessTable.vue'

export default {
  components: {
    BRow,
    BCol,

    NewnessTable
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>